import * as yup from "yup";

const RCIFileUploadValidation = (section: string) => {
  let validationSchema = yup.object().shape({
    trainer: yup.string(),
  });

  if (section === "RCI1") {
   
    validationSchema = validationSchema.shape({
      trainer: yup.string().required("Trainer is required"),
      certificateExpirationDate: yup.date().typeError("Invalid Date, please use MM/DD/YYYY formatting").required("Date is required").test('is-future-date', 'Certificate must be good for at least six months', (certificateExpirationDate: any)=>{
          const sixMonths = new Date();
          sixMonths.setMonth(sixMonths.getMonth() + 6)
          return certificateExpirationDate > sixMonths
        })
    });
  }

  return validationSchema;
};

export default RCIFileUploadValidation;
